import ReassuranceBlock from './ReassuranceBlock.vue'

export default ReassuranceBlock
